/*
 * @Description:
 * @Date: 2019-07-31 16:06:31
 */

export const moneyComplete = val => Math.round(Number(val) * 100); // 转分

export const moneyInt = val => {
  // 用于修改时补位金额
  let money = Number(val) / 100;
  return money.toFixed(2) || 0;
};

export const moneyFixed = num => {
  if (!isNaN(num)) {
    let n = (Number(num) / 100).toFixed(2);
    return n + '元';
  } else {
    return '-';
  }
};

// 判断是否为数字
export const isMoney = value => {
  if (
    !['string', 'number'].includes(typeof value) ||
    isNaN(value) ||
    value === ''
  ) {
    return false;
  }
  return true;
};
export function formatDecimal(value, decimal) {
  if (!isMoney(value)) {
    return '';
  }
  value = value.toString();
  let index = value.indexOf('.');
  if (index !== -1) {
    value = value.substring(0, decimal + index + 1);
  } else {
    value = value.substring(0);
  }
  return parseFloat(value).toFixed(decimal);
}
// 控制数字，有小泽则最多2为，不足补0，无小数则为整数
export function setDefaultDecimal(value) {
  if (isMoney(value)) {
    const splits = (value + '').split('.');
    return formatDecimal(value, splits.length > 1 ? 2 : 0);
  }
  return value;
}
export const twoDecimal = (num, divisor = 1, suffix = '') => {
  if (!isNaN(num)) {
    let _num = Number(num) / divisor;
    if (/^\d+(\.\d{1})$/.test(_num)) {
      _num = _num + '0';
    } else if (!/\./.test(_num)) {
      _num = _num + '.00';
    }
    return _num + suffix;
  } else {
    return '-';
  }
};

// 百分比
export const transScale = function(num) {
  const _num = twoDecimal(num, 1, '%');
  return _num;
};

export const afterTaxPrice = money => {
  if (!isNaN(money)) {
    return (Math.ceil(money * 100 * 1.0675) / 100).toFixed(2);
  } else {
    return '';
  }
};
export const afterTaxPrice2 = money => {
  //给c端计算税率：
  if (!isNaN(money)) {
    return (Math.ceil(money * 100 * 1.0835) / 100).toFixed(2);
  } else {
    return '';
  }
};
